




































import { Component, Vue, Prop, Watch } from 'vue-property-decorator';
import { sessionModule } from '@/trials/store/modules/session';
import { SysConst as SC } from '@/trials/plugins/const';

@Component
export default class SingleSelectDataTable extends Vue {
    // 属性
    /*----------------------------------*
     * Props
     *-----------------------------------*/
    @Prop({ default: 10 })
    private itemsPerPage?: number;

    @Prop({ default: () => [] })
    private dataSet: any[];

    @Prop({ default: true })
    private showIndex: boolean;

    @Prop({ default: () => ({}) })
    private defaultSortBy: { [key: string]: boolean };

    @Prop({ default: null })
    private selectHandler: Function | null;

    @Prop({ default: undefined })
    private caption: string | undefined;

    @Prop({ default: false })
    private withResult: boolean;

    @Prop({ default: 0 })
    private selectedIndex: number;

    /*----------------------------------*
     * Data
     *-----------------------------------*/
    private selected: any = [];
    private selectedId: number = 0;
    private chunkItems: any[] = [];
    private headers: any[] = [];
    private sortBy: string[] = [];
    private sortDesc: boolean[] = [];
    private currentRow: any = null;
    private canSelect: boolean = true;
    private footerProps: { [key: string]: any } = {
        'show-first-last-page': true,
        'items-per-page-options': [5, 10, 20, 30, 50, -1],
    };
    private posColor: string = SC.Color.POSITIVE;
    private negColor: string = SC.Color.NEGATIVE;

    /*----------------------------------*
     * Computed
     *-----------------------------------*/
    /*----------------------------------*
     * ライフサイクルフック
     *-----------------------------------*/
    mounted() {
        // Propsとして受けとったindexを保持
        this.selectedId = this.selectedIndex;

        // データセット作成
        this.makeDataSet();
    }

    /*----------------------------------*
     * Watch
     *-----------------------------------*/
    @Watch('dataSet')
    private changeDataSet() {
        this.makeDataSet();
    }

    /*----------------------------------*
     * Methods
     *-----------------------------------*/
    // データセット作成
    private makeDataSet() {
        this.chunkItems.length = 0;
        this.headers.length = 0;
        for (let i in this.dataSet) {
            if (+i) {
                // items編集
                let tmp_item: any = {};
                tmp_item['selectId'] = +i;
                if (this.showIndex) {
                    tmp_item['index'] = +i;
                }
                for (let j in this.dataSet[i]) {
                    tmp_item['item_' + j] = this.dataSet[i][j];
                }
                this.chunkItems.push(Object.assign({}, tmp_item));
            } else {
                // header編集
                this.headers.push({
                    text: '',
                    value: 'selectId',
                    sortable: false,
                });
                if (this.showIndex) {
                    this.headers.push({
                        text: 'No.',
                        value: 'index',
                        align: 'left',
                    });
                }

                const defaultSortHeaders: string[] = Object.keys(this.defaultSortBy);
                for (let j in this.dataSet[i]) {
                    const header: string = this.dataSet[i][j];
                    const value = 'item_' + j;
                    this.headers.push({ text: header, value: value });

                    // 初期ソートの設定があれば、Datatable用に変換して設定
                    if (defaultSortHeaders.includes(header)) {
                        this.sortBy.push(value);
                        this.sortDesc.push(this.defaultSortBy[header]);
                    }
                }
            }
        }
    }

    private clearSelected(): void {
        this.selected = [];
        this.currentRow = null;
        this.selectedId = 0;
    }

    private rollbackSelected(prevRow: any): void {
        if (prevRow != null) {
            // 既存状態があるので、そこに戻す
            prevRow.select(true);
            this.currentRow = prevRow;
            this.selectedId = prevRow.item['selectId'];
        } else {
            // 既存状態がないので、選択解除
            this.clearSelected();
        }
    }

    // 行クリック時の処理
    private async rowClickHander(item: any, row: any): Promise<void> {
        // クリックハンドラの処理が終わるまで、次の処理はさせない
        if (!row.isSelected && this.canSelect) {
            this.canSelect = false;

            // 表示上は選択した行をactiveにする
            row.select(true);
            this.selectedId = item['selectId'];

            // エラーだった場合にもとの行をactiveにする準備
            const prevRow = this.currentRow;

            // handler実行
            const result = await this.selectHandler(row);

            // 処理結果に応じて行の状態を変更
            if (result) {
                this.currentRow = row;
            } else {
                this.rollbackSelected(prevRow);
            }

            this.canSelect = true;
        }
    }
}
